// -----------------------------------------------------------------------------
// engine/compositor/shaders/quad.ts — the one shader pair Tier 0 needs.
//
// A textured quad with a per-draw opacity. Every layer (video frame, still
// image, or rendered text) is drawn as a textured rectangle through this program.
// Tier 1/2 add filter/effect/transition shaders alongside this baseline.
// -----------------------------------------------------------------------------

export const QUAD_VERTEX_SHADER = `#version 300 es
in vec2 a_pos;   // clip-space position (-1..1)
in vec2 a_uv;    // texture coordinate (0..1)
out vec2 v_uv;
void main() {
  v_uv = a_uv;
  gl_Position = vec4(a_pos, 0.0, 1.0);
}
`;

export const QUAD_FRAGMENT_SHADER = `#version 300 es
precision mediump float;
in vec2 v_uv;
uniform sampler2D u_tex;
uniform float u_opacity;
// Colour grade (all 0 = no change).
uniform float u_brightness;
uniform float u_contrast;
uniform float u_saturation;
uniform float u_temperature;
out vec4 outColor;

vec3 grade(vec3 c) {
  c += u_brightness;                                  // brightness: lift/drop
  c = (c - 0.5) * (1.0 + u_contrast) + 0.5;           // contrast: around mid-grey
  float luma = dot(c, vec3(0.299, 0.587, 0.114));
  c = mix(vec3(luma), c, 1.0 + u_saturation);         // saturation: toward/away from grey
  c += vec3(u_temperature * 0.12, 0.0, -u_temperature * 0.12); // warm/cool
  return clamp(c, 0.0, 1.0);
}

void main() {
  vec4 c = texture(u_tex, v_uv);
  outColor = vec4(grade(c.rgb), c.a * u_opacity);
}
`;
